/* eslint-disable no-undef */
// 高德地图开发者key
const key = "c9d57c8b7acb71c1a5f9fa2a2bdc0009";
const webServiceBaseUrl = "https://restapi.amap.com/v3";
import jsonp from "jsonp";

class MapService {
  /**
   * 坐标转地址信息
   * @param location {{Object}} 地址位置（如果不传，sdk默认会使用当前位置） 格式如下：
   * {
   *   latitude: 纬度,
   *   longitude: 经度
   * }
   * @param getPoi {{Number}} 是否返回周边POI列表 1.返回；0不返回(默认)
   * @param poiOptions {{Object}} poi配置项, 具体参考高德地图文档,
   * {
   *    radius: 200, 半径，取值范围 1-3000（米）
   * }
   *
   */
  static reverseGeocoder(location, getPoi = 0, poiOptions) {
    return new Promise((resolve, reject) => {
      let query = "";
      const param = {
        output: "json",
        key
      };
      if (location)
        param.location = location.longitude + "," + location.latitude;
      // 是否获取poi信息
      if (getPoi) {
        param.extensions = getPoi == 0 ? "base" : "all";
        if (
          poiOptions &&
          Object.prototype.toString.call(poiOptions) === "[object Object]"
        ) {
          for (let keys in poiOptions) {
            param[keys] = poiOptions[keys];
          }
        }
      }
      for (let key in param) {
        query += `${key}=${param[key]}&`;
      }
      jsonp(
        `${webServiceBaseUrl}/geocode/regeo?${query}`,
        null,
        (err, data) => {
          if (err) return reject(err);
          if (data.status === "1" && data.info === "OK") {
            resolve(data);
          } else {
            reject(data);
          }
        }
      );
    });
  }

  /**
   * 搜索地址
   * @param {string} keywords
   * @param {string} citylimit
   */
  static search(keywords = "", city = "", citylimit = false) {
    return new Promise((resolve, reject) => {
      const query = `key=${key}&keywords=${keywords}&city=${city}&citylimit=${citylimit}`;
      jsonp(`${webServiceBaseUrl}/place/text?${query}`, null, (err, data) => {
        if (err) return reject(err);
        if (data.status === "1" && data.info === "OK") {
          const poiItems = data.pois || [];
          poiItems.forEach(val => {
            const location = val.location.split(",");
            val.location = {
              lat: Number(location[1]),
              lng: Number(location[0])
            };
            val.ad_info = {
              city: val.cityname,
              name: val.name,
              district: val.adname
            };
          });
          data.data = poiItems;
          resolve(data);
        } else {
          reject(data);
        }
      });
    });
  }

  /**
   * 获取定位信息
   * 默认坐标系gcj02
   */
  static getLocation() {
    return new Promise((resolve, reject) => {
      try {
        wx.ready(() => {
          wx.getLocation({
            type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function(res) {
              // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              // var speed = res.speed; // 速度，以米/每秒计
              // var accuracy = res.accuracy; // 位置精度
              resolve(res);
            },
            fail: function(e) {
              reject(e);
            }
          });
        });
        wx.error(e => {
          reject(e);
        });
      } catch (e) {
        reject(e);
      }
    });
  }
}

export default MapService;
